import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { GenericHttp } from './generic-http.service';
import { Config } from '@config/config.service';

@Injectable()
export class SessionsApiService {
  private sessionsDataUrl: string;
  private sessionInfoUrl: string;
  private sessionFilesUrl: string;
  private invitationsMyPageDataUrl: string;

  constructor(
    private trbhttp: GenericHttp,
    private config: Config,
  ) {
    this.sessionsDataUrl = config.sessionsDataUrl;
    this.sessionInfoUrl = config.sessionInfoUrl;
    this.sessionFilesUrl = config.sessionFilesUrl;
    this.invitationsMyPageDataUrl = config.invitationsMyPageDataUrl;
  }

  getSessionsData(filterData): Observable<any> {
    return this.trbhttp.get(
      this.sessionsDataUrl,
      filterData
    );
  }

  getMyPageInvitationsData(filterData): Observable<any> {
    return this.trbhttp.get(
      this.invitationsMyPageDataUrl,
      filterData
    );
  }

  getSessionInfo(sessionId: string): Observable<any> {
    const url = this.sessionInfoUrl.replace('{sessionId}', sessionId);

    return this.trbhttp.get(url);
  }

  getSessionFiles(sessionId: string): Observable<any> {
    const url = this.sessionFilesUrl.replace('{sessionId}', sessionId);

    return this.trbhttp.get(url);
  }
}
